export default __webpack_public_path__ + "media/star-effect.edfed5e1.svg";